import firebase from 'firebase'
import { isFunction, camelCase } from 'lodash'

let disabled

export const disableAnalytics = () => (disabled = true)

export const initiatePurchase = params => {
  if (disabled) return

  const timestamps = { init: new Date() }
  firebase
    .database()
    .ref(`purchaseAnalytics/${params.purchaseId}`)
    .set({
      ...params,
      purchaseId: params.purchaseId,
      renders: 0,
    })
  firebase
    .database()
    .ref(`purchaseAnalytics/${params.purchaseId}/timestamps`)
    .update(timestamps)
}

export const updatePurchase = (purchaseId, params) => {
  if (disabled) return

  const ref = firebase.database().ref(`purchaseAnalytics/${purchaseId}`)

  if (isFunction(params)) {
    ref
      .once('value')
      .then(snap => {
        const attributes = params(snap.val())
        if (attributes !== null) ref.update(attributes)
      })
      .catch(() => updatePurchase(purchaseId, params))
  } else {
    ref.update(params)
  }
}

export const incrementPurchaseRenders = purchaseId => {
  if (disabled) return

  updatePurchase(purchaseId, ({ renders }) => ({ renders: renders + 1 }))
}

export const timestampPurchase = (purchaseId, action) => {
  if (disabled) return

  const name = camelCase(action)
  const stamp = new Date()
  updatePurchase(purchaseId + '/timestamps', timestamps => {
    if (timestamps && timestamps[name]) return null
    return { [name]: stamp }
  })
}



// WEBPACK FOOTER //
// ./src/analytics.js